// Avisos cortos en pantalla (reemplazan alert()). Desde cualquier parte: aviso("Álbum creado")
// o aviso("No se pudo guardar", "error"). <Avisos /> se monta una sola vez en App.
import { useEffect, useState } from "react";

export const aviso = (texto, tipo = "ok") =>
    window.dispatchEvent(new CustomEvent("aviso", { detail: { texto, tipo } }));

let siguienteId = 0;

export default function Avisos() {
    const [lista, setLista] = useState([]);

    useEffect(() => {
        const nuevo = (e) => {
            const id = siguienteId++;
            setLista((prev) => [...prev, { id, ...e.detail }]);
            // Los errores se quedan más tiempo para alcanzar a leerlos
            setTimeout(() => setLista((prev) => prev.filter((a) => a.id !== id)), e.detail.tipo === "error" ? 7000 : 3500);
        };
        window.addEventListener("aviso", nuevo);
        return () => window.removeEventListener("aviso", nuevo);
    }, []);

    return (
        <div className="avisos" role="status" aria-live="polite">
            {lista.map((a) => (
                <div key={a.id} className={`aviso ${a.tipo}`}>
                    <span>{a.texto}</span>
                    <button
                        type="button"
                        aria-label="Cerrar aviso"
                        onClick={() => setLista((prev) => prev.filter((x) => x.id !== a.id))}
                    >
                        ✕
                    </button>
                </div>
            ))}
        </div>
    );
}
